import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from 'hx-util';
import { BsChevronUp } from 'react-icons/bs';
export function ChevronIcon(_a) {
    var isOpen = _a.isOpen;
    return _jsx(BsChevronUp, { className: cn('text-xs', { 'rotate-180': !isOpen }) });
}
